import React from 'react';
import * as S from './ProductBanners.styled';
export const ProductBanners = ({ productBanners }) => {
    if (productBanners.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, null, productBanners.map((component, index) => (React.createElement(S.Banner, { key: index }, component)))));
};
